<button *ngIf="rowData.idReport != null && rowData.reportedExaminationsNumber !== null && rowData.reportedExaminationsNumber > 1"
        class="attached-icon-button se-button-no-ripple attached-icon-button-color"
        [disableRipple]="true"
        mat-icon-button
        matTooltipShowDelay="500"
        matTooltipClass="custom-tooltip"
        #tooltip="matTooltip"
        [matTooltip]="'HasAssociatedExaminations' | translate"
        (click)="onIconClick($event)">
    <mat-icon *ngIf="!loading">link</mat-icon>
    <mat-spinner *ngIf="loading"></mat-spinner>
</button>
<div *ngIf="rowData.idReport === null && rowData.examinationsNumber > 1" style="display:flex">
    <mat-icon class="attached-icon-button-color"
              svgIcon="associations-visit"
              matTooltipShowDelay="500"
              matTooltipClass="custom-tooltip"
              #tooltip="matTooltip"
              [matTooltip]="'HasAssociatedExaminations' | translate">
    </mat-icon>
</div>
